import { Chip } from "@heroui/react";

import { ImageTile } from "@/components/kit";
import { ScrapedProduct } from "@/types/scraped-product";

interface SelectableScrapedProductCardProps {
  scrapedProduct: ScrapedProduct;
  isSelected: boolean;
  isPrimary: boolean;
  onSelect: (id: string) => void;
}

/** One candidate row of the change-primary list: a radio, the picture, the names, the price and stock. */
export const SelectableScrapedProductCard = ({
  scrapedProduct,
  isSelected,
  isPrimary,
  onSelect,
}: SelectableScrapedProductCardProps) => {
  return (
    <div
      aria-checked={isSelected}
      className={`flex cursor-pointer items-center gap-3 rounded-xl px-3 py-2.5 outline-none focus-visible:ring-2 focus-visible:ring-(--focus) ${
        isSelected ? "bg-accent/10" : "hover:bg-surface-secondary"
      }`}
      role="radio"
      tabIndex={0}
      onClick={() => onSelect(scrapedProduct.id)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onSelect(scrapedProduct.id);
        }
      }}
    >
      <span
        aria-hidden="true"
        className={`flex size-4 shrink-0 items-center justify-center rounded-full border ${
          isSelected ? "border-accent bg-accent" : "border-border"
        }`}
      >
        {isSelected && <span className="size-1.5 rounded-full bg-white" />}
      </span>
      <ImageTile src={scrapedProduct.images?.[0]} />
      <div className="flex min-w-0 flex-1 flex-col leading-tight">
        <p className="truncate text-sm font-medium" title={scrapedProduct.name}>
          {scrapedProduct.name}
        </p>
        <p className="text-muted truncate text-xs">
          {scrapedProduct.supplier.name}
        </p>
      </div>
      {isPrimary && (
        <Chip color="accent" variant="soft">
          Current Primary
        </Chip>
      )}
      <span className="text-sm tabular-nums">
        AED {scrapedProduct.price.toFixed(2)}
      </span>
      <Chip
        color={scrapedProduct.stockAvailability ? "success" : "danger"}
        variant="soft"
      >
        {scrapedProduct.stockAvailability ? "In Stock" : "Out of Stock"}
      </Chip>
    </div>
  );
};
